import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  background: #fcff7c;
  width: 100%;
  transition: filter 0.2s ease-in;

  @media (min-width: 768px) {
    display: none;
  }

  cursor: pointer;

  &:hover {
    filter: brightness(0.9);
  }

  .cadastroNav {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #2253f5;
    gap: 6px;

    font-family: Montserrat;
    font-style: normal;
    font-weight: bold;
    font-size: 14px;

    color: #2253f5;
  }
`;
